/* istanbul ignore file */

export { ArticleImageGallery as default } from "./ArticleImageGallery";
